import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ReportPopupService } from './report-popup.service';

@Component({
  selector: 'app-report-popup',
  templateUrl: './report-popup.component.html',
  styleUrls: ['./report-popup.component.scss']
})
export class ReportPopupComponent implements OnInit {

  // Login form state
  userData = { login: '', password: '' };
  isLoading = false;
  showPassword = false;

  // Request Access form state
  showRequestAccess = false;
  isRequestLoading = false;
  requestData = { username: '', email: '', phone: '' };
  requestErrors = { username: '', email: '', phone: '' };

  constructor(
    public activeModal: NgbActiveModal,
    private reportPopupService: ReportPopupService,
    private toastr: ToastrService
  ) { }

  ngOnInit() { }

  closePopup() {
    this.activeModal.dismiss();
  }

  showRequestForm() {
    this.showRequestAccess = true;
  }

  cancelRequest() {
    this.showRequestAccess = false;
    this.requestData = { username: '', email: '', phone: '' };
    this.requestErrors = { username: '', email: '', phone: '' };
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    return /[0-9]/.test(event.key);
  }

  private validateRequestForm(): boolean {
    let valid = true;
    this.requestErrors = { username: '', email: '', phone: '' };
    if (!this.requestData.username.trim()) {
      this.requestErrors.username = 'Username is required.';
      valid = false;
    }
    if (!this.requestData.email.trim()) {
      this.requestErrors.email = 'Email is required.';
      valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.requestData.email)) {
      this.requestErrors.email = 'Enter a valid email address.';
      valid = false;
    }
    if (!this.requestData.phone.trim()) {
      this.requestErrors.phone = 'Phone number is required.';
      valid = false;
    } else if (!/^\d{10}$/.test(this.requestData.phone)) {
      this.requestErrors.phone = 'Phone number must be exactly 10 digits.';
      valid = false;
    }
    return valid;
  }

  submitRequest() {
    if (!this.validateRequestForm()) { return; }
    this.isRequestLoading = true;

    // createBasicUser API only accepts name, email, phoneNumber
    const payload = {
      name: this.requestData.username,
      email: this.requestData.email,
      phoneNumber: this.requestData.phone
    };

    this.reportPopupService.createBasicUser(payload).subscribe(
      (response) => {
        this.isRequestLoading = false;
        if (response && response.status === 'success') {
          this.toastr.success('Downloaded successfully');
          this.activeModal.close({ success: true });
        } else {
          this.toastr.error(response && response.message ? response.message : 'Something went wrong. Please try again.');
        }
      },
      (error) => {
        this.isRequestLoading = false;
        const msg = error.error && error.error.message
          ? error.error.message
          : 'Something went wrong. Please try again.';
        this.toastr.error(msg);
      }
    );
  }
  
  onSubmit() {
    if (!this.userData.login || !this.userData.password) {
      this.toastr.error('Please enter username and password');
      return;
    }

    this.isLoading = true;

    this.reportPopupService.authenticate(this.userData.login, this.userData.password).subscribe(
      (response) => {
        this.isLoading = false;
        if (response && (response.status === true || (response.status === undefined && response.data))) {
          const allowed = response.allowedToCreateUser !== undefined
            ? response.allowedToCreateUser
            : !!(response.data && response.data.allowedToCreateUser);
          localStorage.setItem('allowedToCreateUser', JSON.stringify(allowed));

          this.reportPopupService.setMetaInfo(response.data, this.userData.login).then(() => {
            this.toastr.success('Downloaded Sucessfully');
            this.activeModal.close({ success: true });
          }).catch(() => {
            this.toastr.error('Failed to fetch location info. Please try again.');
          });
        } else {
          this.toastr.error(response.message || 'Invalid username or password');
        }
      },
      (error) => {
        this.isLoading = false;
        const msg = error.error && error.error.message
          ? error.error.message
          : 'Login failed. Please try again.';
        this.toastr.error(msg);
      }
    );
  }
}